export const API_NEW_URL = "https://connect.knvmmedicare.com/api/";
export const DOC_URL = "https://connect.knvmmedicare.com/";
export const IMG_URL = "https://connect.knvmmedicare.com";
// export const API_NEW_URL = "http://localhost:3001/api/";
export const X_API_Key = "9e654ad7d5d4d3941f77115e18de1d2d1b7fb2c69e6fb32ac75f7e529db1ff97";
export const MAIN_URL = "https://api.brandshow.in/knvm/";
